import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const getEmployeeMasterDetails = async (
  org_id: any,
  employee_id: any
) => {
  const path = `/orgs/${org_id}/employee/${employee_id}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
